import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../constants/colors";

export default makeStyles((theme) => ({
  pageHeader: {
    textAlign: "center",
    width: "100%",
  },
  pageHeaderTitle: {
    color: `${COLORS.accent}`,
    textDecoration: "underline",
    marginBottom: "10px",
    marginTop: "5px",
    fontFamily: "Montserrat",
  },
  noProductsText: {
    fontFamily: "Montserrat",
    color: `${COLORS.accent}`,
  },
  mainContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "48vh",
  },
  productsContainer: {
    width: "100%",
    margin: 0,
    padding: 10,
    opacity: 0,
    animation: "$displayProducts 2s 1 forwards",
  },
  loader: {
    color: `${COLORS.accent}`,
  },
  "@keyframes displayProducts": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
}));
